export const convertCmToFeetInches = (cm) => {
    if (!cm || isNaN(cm)) return { feet: null, inches: null };
    const totalInches = cm / 2.54; 
    const feet = Math.floor(totalInches / 12);
    const inches = Math.round(totalInches % 12);
    return { feet, inches };
};

export const convertFeetInchesToCm = (feet, inches) => {
    if (feet === null || inches === null || isNaN(feet) || isNaN(inches)) return null;
    const totalInches = (parseInt(feet) * 12) + parseInt(inches);
    return (totalInches * 2.54); 
};

export const convertCmToMeters = (cm) => {
    if (!cm || isNaN(cm)) return '';
    return (cm / 100).toFixed(2); 
};